import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { environment } from '@journal/env/environment';
import { map } from 'rxjs/operators';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = `${environment.baseUrl}`;
  authChange = new Subject();
  user = null;

  constructor(private http: HttpClient, private metaService: MetaService) {
    this.baseUrl = `${environment.serverUrl}${this.baseUrl}`;
  }

  getUser() {
    return this.http.get(this.baseUrl + 'profiles/auth/').pipe(
      map(response => {
        return this.metaService.decodeApiResponse(response);
      })
    );
  }

  getHeavyUser(user_pk: number) {
    return this.http.get(this.baseUrl + 'profiles/' + user_pk + '/heavy/');
  }

  getCurrentUser() {
    return this.user;
  }
}
